export function setAuthData(token, expires) {
    try {
        localStorage.setItem('authToken', token);
        localStorage.setItem('expires', expires);
    } catch (e) {
        // localStorage might be unavailable (e.g. Safari private mode)
    }
    setCookie('authToken', token, expires);
    setCookie('expires', expires, expires);
}

export function clearAuthData() {
    try {
        localStorage.removeItem('authToken');
        localStorage.removeItem('expires');
        localStorage.removeItem('isAuthorized');
        localStorage.removeItem('groupsid');
        localStorage.removeItem('userName');
        localStorage.removeItem('userId');
    } catch (e) {}
    removeCookie('authToken');
    removeCookie('expires');
}

export function restoreAuthFromCookie() {
    const token = getCookie('authToken');
    const expires = getCookie('expires');
    try {
        if (token && !localStorage.getItem('authToken')) {
            localStorage.setItem('authToken', token);
        }
        if (expires && !localStorage.getItem('expires')) {
            localStorage.setItem('expires', expires);
        }
    } catch (e) {
        // localStorage may be unavailable
    }
}

function setCookie(name, value, expires) {
    let exp = '';
    if (expires) {
        const date = new Date(expires);
        if (!isNaN(date.getTime())) {
            exp = '; expires=' + date.toUTCString();
        }
    }
    document.cookie = `${name}=${encodeURIComponent(value || '')}${exp}; path=/`;
}

function getCookie(name) {
    const match = document.cookie.match('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
}

function removeCookie(name) {
    document.cookie = `${name}=; Max-Age=0; path=/`;
}
